var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.62V16.22C15 15.6599 15 15.3799 14.891 15.166C14.7951 14.9778 14.6422 14.8249 14.454 14.729C14.2401 14.62 13.9601 14.62 13.4 14.62H10.6C10.0399 14.62 9.75992 14.62 9.54601 14.729C9.35785 14.8249 9.20487 14.9778 9.10899 15.166C9 15.3799 9 15.6599 9 16.22V21.62M19 21.62V6.82C19 5.69989 19 5.13984 18.782 4.71201C18.5903 4.33569 18.2843 4.02973 17.908 3.83798C17.4802 3.62 16.9201 3.62 15.8 3.62H8.2C7.07989 3.62 6.51984 3.62 6.09202 3.83798C5.71569 4.02973 5.40973 4.33569 5.21799 4.71201C5 5.13984 5 5.69989 5 6.81999V21.62M21 21.62H3M9.5 8.62H9.51M14.5 8.62H14.51M10 8.62C10 8.89614 9.77614 9.12 9.5 9.12C9.22386 9.12 9 8.89614 9 8.62C9 8.34385 9.22386 8.12 9.5 8.12C9.77614 8.12 10 8.34385 10 8.62ZM15 8.62C15 8.89614 14.7761 9.12 14.5 9.12C14.2239 9.12 14 8.89614 14 8.62C14 8.34385 14.2239 8.12 14.5 8.12C14.7761 8.12 15 8.34385 15 8.62Z",
    stroke: "#B1B6BF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.a489e5737c5afc8cf06cd7ec75967f6d.svg";
export { ForwardRef as ReactComponent };